<template>

  <v-row>
    <v-col :cols="noWatchlist ? 7 : 12">
      <p>Lege dir eine neue Watchlist an und behalte die Wertpapiere im Blick, die dich interessieren.</p>
      <v-btn outlined tile @click="$emit('showCreateWatchlistDialog')">
        <fin-subscription-lock v-if="!newWatchListAllowed"/>
        Neue Watchlist
      </v-btn>
    </v-col>
    <v-col :class="(noWatchlist ? '' : 'justify-end') + ' d-flex'"
           :cols="noWatchlist ? 5 : 12">
      <v-img :max-width="120"
             :src="require('@/assets/myFinHub/fin-new-watchlist.svg')"
             class="mt-n5"
             contain/>
    </v-col>
  </v-row>

</template>


<script>

import FinSubscriptionLock from "@/components/common/subscription/lock"

export default {
  name: 'fin-new-watchlist',
  components: {FinSubscriptionLock},
  props: {
    noWatchlist: {
      type: Boolean,
      default: false
    },
    newWatchListAllowed: {
      type: Boolean,
      default: true
    }
  }
}
</script>


<style lang="scss" scoped>

</style>
